/**
 * Llamadas HTTP del dominio Notificaciones (campana de pedidos de láminas).
 *
 * SIEMPRE sobre el cliente único `lib/api` (`docs/frontend_architecture.md`,
 * Pr. 2): ningún `fetch`/`ky` suelto. El cliente ya aporta `credentials: 'include'`,
 * el `X-CSRF-TOKEN` y el `X-Sede-Id` (sede activa) en cada request, así que las
 * notificaciones se piden/marcan para la sede activa sin tocar la cabecera a mano (el
 * backend resuelve y valida la sede con `resolve_api_sede`).
 *
 * Cubre las dos rutas del endpoint de notificaciones de
 * `application/api/domains/pedidos_lamina.py` (réplica REST de las rutas SSR
 * `pedido_lamina_notifs_recientes` / `marcar_pedido_notifs_vistas`):
 * recientes (polling) y marcar-vistas. Un `ApiError` (401/403/5xx) lo propaga el
 * cliente y lo gestionan los hooks/componente.
 */
import { api } from "@/lib/api";

import type { PedidoNotificationsResponse } from "./types";

/**
 * Notificaciones de pedidos de láminas no vistas de la sede activa
 * (`GET /pedidos-laminas/notificaciones`).
 *
 * Permiso backend: `view_pedidos_laminas`. La sede la inyecta el cliente
 * (`X-Sede-Id`) y la valida el backend; el service devuelve `{count, notifs}`.
 */
export async function fetchNotifications(): Promise<PedidoNotificationsResponse> {
  const response = await api.get("pedidos-laminas/notificaciones");
  return (await response.json()) as PedidoNotificationsResponse;
}

/**
 * Marca como vistas las notificaciones de la sede activa
 * (`POST /pedidos-laminas/notificaciones/marcar-vistas`).
 *
 * Permiso backend: `view_pedidos_laminas`. Devuelve `{ok}` (no se necesita el
 * cuerpo en el cliente: tras marcar, se refresca el conteo).
 */
export async function markNotificationsSeen(): Promise<void> {
  await api.post("pedidos-laminas/notificaciones/marcar-vistas");
}
